export const french = {
  common: {
    error: 'Erreur',
    warning: 'Avertissement',
    color: {
      colorPicker: {
        hex: 'Hex',
        r: 'R',
        g: 'V',
        b: 'B',
        sliderHue: 'Couleur',
        sliderOpacity: 'Opacité de la couleur'
      }
    }
  },
  mainCanvasActions: {
    buttonExport: 'Enregistrer',
    buttonUndo: 'Annuler',
    buttonRedo: 'Rétablir',
    buttonClose: 'Fermer'
  },
  infoModals: {
    exporting: {
      heading: 'Exportation en cours...',
      body: 'Patientez quelques instants...'
    },
    saving: {
      heading: 'Enregistrement en cours...',
      body: 'Patientez quelques instants...'
    },
    loading: {
      heading: 'Chargement...',
      body: 'Patientez quelques instants...'
    },
    resizing: {
      heading: 'Redimensionnement...',
      body: 'Patientez quelques instants...'
    },
    loadingFonts: {
      heading: 'Chargement des polices...',
      body: 'Patientez quelques instants...'
    },
    stickerLoading: {
      heading: 'Chargement des autocollants...',
      body: 'Patientez quelques instants...'
    }
  },
  errorModals: {
    imageLoading: {
      headingDelimiter: ' :',
      body:
      "Échec du chargement de l'image. Cela peut être dû à plusieurs raisons, par exemple, le fichier est corrompu ou le type de fichier n'est pas pris en charge.",
      buttonYes: 'Réessayer',
      buttonNo: 'Fermer'
    },
    rendering: {
      headingDelimiter: ' :',
      body: "Une erreur s'est produite lors du rendu de l'image.",
      buttonYes: 'Réessayer',
      buttonNo: 'Fermer'
    },
    fontLoading: {
      headingDelimiter: ' :',
      heading: 'Impossible de charger la police',
      body: 'Les polices suivantes n\'ont pas pu être chargées : ${error}',
      buttonNo: 'Fermer'
    },
    webcamUnavailable: {
      headingDelimiter: ' :',
      body: "Impossible d'afficher l'image de la webcam (Erreur : ${error})",
      buttonYes: 'Fermer'
    },
    stickerLoading: {
      headingDelimiter: ' :',
      body: "Impossible de charger l'autocollant",
      buttonNo: 'Fermer'
    },
    unexpectedError: {
      headingDelimiter: ' :',
      body: 'Une erreur inattendue s\'est produite ${error}',
      buttonYes: 'Réessayer',
      buttonNo: 'Fermer'
    }
  },
  warningModals: {
    imageResized: {
      headingDelimiter: ' :',
      heading: 'Image redimensionnée',
      body:
      'Votre image dépasse la taille maximale de ${megapixels} mégapixels et a été redimensionnée en ${width}x${height} pixels',
      buttonYes: 'Continuer'
    },
    unsupportedSerializationVersion: {
      headingDelimiter: ' :',
      body:
      "Vos données ont été restaurées à partir d'un format de données obsolète et peuvent apparaître différemment",
      buttonYes: 'Appliquer les modifications',
      buttonNo: 'Annuler'
    },
    discardChanges: {
      headingDelimiter: ' :',
      body:
      'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir supprimer les modifications ?',
      buttonYes: 'Supprimer les modifications',
      buttonNo: 'Conserver les modifications'
    },
    unsavedChanges: {
      headingDelimiter: ' :',
      body: 'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter ?',
      buttonYes: 'Quitter',
      buttonNo: 'Annuler'
    },
    unsupportedWebGLRenderer: {
      body:
      'Un problème a été détecté dans le navigateur, ce qui pourrait entraîner des temps de chargement prolongés. Veuillez essayer un navigateur différent.',
      buttonYes: 'Continuer'
    }
  },
  library: {
    title: 'Bibliothèque',
    controls: {
      buttonUpload: 'Importer une image',
      buttonWebcamOpen: 'Ouvrir la webcam',
      buttonWebcamClose: 'Fermer la webcam',
      placeholderSearch: 'Rechercher dans la bibliothèque',
      noResults: 'Aucun résultat'
    }
  },
  filter: {
    title: 'Filtres',
    controls: {
      buttonReset: 'Supprimer le filtre',
      sliderIntensity: 'Intensité du filtre'
    },
    categories: {
      imgly_filter_category_duotone: 'DuoTone',
      imgly_filter_category_bw: 'Noir et blanc',
      imgly_filter_category_vintage: 'Vintage',
      imgly_filter_category_smooth: 'Doux',
      imgly_filter_category_cold: 'Froid',
      imgly_filter_category_warm: 'Chaud',
      imgly_filter_category_legacy: 'Héritage'
    },
    items: {
      imgly_lut_celsius: 'Inferno',
      imgly_lut_chest: 'Marron',
      imgly_lut_fixie: 'Fixie',
      imgly_lut_fridge: 'Réfrigérateur',
      imgly_lut_front: 'Soleil des années 70',
      imgly_lut_k2: 'Noir plat',
      imgly_lut_mellow: 'Doux',
      imgly_lut_sin: 'Choses dures',
      imgly_lut_texas: 'Voiture ancienne',
      imgly_lut_ad1920: '1920 A.D.',
      imgly_lut_ancient: 'Ancien',
      imgly_lut_bleached: 'Kalmen',
      imgly_lut_bleachedblue: 'Joran',
      imgly_lut_blues: 'Polaroid',
      imgly_lut_blueshadows: 'Zephyr',
      imgly_lut_breeze: 'Levante',
      imgly_lut_bw: 'Grisé',
      imgly_lut_classic: 'Classique',
      imgly_lut_colorful: 'Coloré',
      imgly_lut_cool: 'Vif',
      imgly_lut_cottoncandy: 'Bonbon',
      imgly_lut_creamy: 'Crémeux',
      imgly_lut_eighties: 'Feu bas',
      imgly_lut_elder: 'Colla',
      imgly_lut_evening: 'Lever de soleil',
      imgly_lut_fall: 'Mousse',
      imgly_lut_food: 'Nourriture',
      imgly_lut_glam: 'Glam',
      imgly_lut_gobblin: 'Gobblin',
      imgly_lut_highcarb: 'Riches en glucides',
      imgly_lut_highcontrast: 'Hicon',
      imgly_lut_k1: 'K1',
      imgly_lut_k6: 'K6',
      imgly_lut_kdynamic: 'Caillou',
      imgly_lut_keen: 'Keen',
      imgly_lut_lenin: 'Citron',
      imgly_lut_litho: 'Litho',
      imgly_lut_lomo: 'Lomo',
      imgly_lut_lomo100: 'Lomo 100',
      imgly_lut_lucid: 'Lucid',
      imgly_lut_neat: 'Net',
      imgly_lut_nogreen: 'Potiron',
      imgly_lut_orchid: 'Solanus',
      imgly_lut_pale: 'Pâle',
      imgly_lut_pitched: 'Pitched',
      imgly_lut_plate: 'Vieilli',
      imgly_lut_pola669: 'Green Gap',
      imgly_lut_polasx: 'Pola SX',
      imgly_lut_pro400: 'Pro 400',
      imgly_lut_quozi: 'Quozi',
      imgly_lut_sepiahigh: 'Sépia',
      imgly_lut_settled: 'Stable',
      imgly_lut_seventies: 'Années 70',
      imgly_lut_soft: 'Doux',
      imgly_lut_steel: 'Acier',
      imgly_lut_summer: 'Été',
      imgly_lut_sunset: 'Doré',
      imgly_lut_tender: 'Tendre',
      imgly_lut_twilight: 'Crépuscule',
      imgly_lut_winter: 'Doux',
      imgly_lut_x400: 'Poussiéreux',
      imgly_duotone_desert: 'Désert',
      imgly_duotone_peach: 'Pêche',
      imgly_duotone_clash: 'Conflit',
      imgly_duotone_plum: 'Prune',
      imgly_duotone_breezy: 'Agréable',
      imgly_duotone_deepblue: 'Bleu profond',
      imgly_duotone_frog: 'Grenouille',
      imgly_duotone_sunset: 'Coucher de soleil'
    }
  },
  adjustment: {
    title: 'Ajustements',
    controls: {
      buttonReset: 'Réinitialiser'
    },
    categories: {
      basics: 'Base',
      refinements: 'Avancé'
    },
    items: {
      brightness: 'Luminosité',
      saturation: 'Saturation',
      contrast: 'Contraste',
      gamma: 'Gamma',
      sharpness: 'Netteté',
      clarity: 'Clarté',
      exposure: 'Exposition',
      shadows: 'Ombres',
      highlights: 'Hautes lumières',
      whites: 'Blancs',
      blacks: 'Noirs',
      temperature: 'Température'
    }
  },
  focus: {
    title: 'Mise au point',
    controls: {
      buttonReset: 'Supprimer la mise au point',
      sliderIntensity: 'Intensité de la mise au point'
    },
    items: {
      radial: 'Radiale',
      mirrored: 'Miroir',
      linear: 'Linéaire',
      gaussian: 'Gaussien'
    },
    history: {
      focusPosition: 'Position de la mise au point',
      focusSize: 'Taille de la mise au point'
    }
  },
  overlay: {
    title: 'Superpositions',
    controls: {
      buttonReset: 'Supprimer la superposition',
      sliderOpacity: 'Opacité de la superposition',
      carouselBlendMode: 'Mode de fusion de la superposition',
      blendModeNormal: 'Normal',
      blendModeOverlay: 'Superposition',
      blendModeHardLight: 'Lumière dure',
      blendModeSoftLight: 'Lumière douce',
      blendModeMultiply: 'Multiplier',
      blendModeDarken: 'Obscurcir',
      blendModeLighten: 'Éclaircir',
      blendModeScreen: 'Écran',
      blendModeColorBurn: 'Incrustation couleur',
      tabOpacity: 'Opacité',
      tabBlendMode: 'Mode de fusion'
    },
    items: {
      imgly_overlay_bokeh: 'Bokeh',
      imgly_overlay_chop: 'Trancher',
      imgly_overlay_clouds: 'Nuages',
      imgly_overlay_golden: 'Doré',
      imgly_overlay_grain: 'Grain',
      imgly_overlay_hearts: 'Cœurs',
      imgly_overlay_lightleak1: 'Fuite de lumière 1',
      imgly_overlay_lightleak2: 'Fuite de lumière 2',
      imgly_overlay_metal: 'Métal',
      imgly_overlay_mosaic: 'Mosaique',
      imgly_overlay_painting: 'Peinture',
      imgly_overlay_paper: 'Papier',
      imgly_overlay_rain: 'Pluie',
      imgly_overlay_vintage: 'Vintage',
      imgly_overlay_wall1: 'Mur',
      imgly_overlay_wall2: 'Mur 2',
      imgly_overlay_wood: 'Bois'
    }
  },
  sticker: {
    title: 'Autocollants',
    controls: {
      buttonUpload: 'Importer un autocollant',
      sliderOpacity: 'Opacité de l\'autocollant',
      selectColor: 'Couleur de l\'autocollant',
      tabColor: 'Couleur',
      tabOpacity: 'Opacité'
    },
    categories: {
      imgly_sticker_emoticons: 'Émoticônes',
      imgly_sticker_shapes: 'Formes',
      imgly_sticker_custom: 'Personnalisé'
    },
    items: {
      imgly_sticker_emoticons_alien: 'Alien',
      imgly_sticker_emoticons_angel: 'Ange',
      imgly_sticker_emoticons_angry: 'Fâché',
      imgly_sticker_emoticons_anxious: 'Anxieux',
      imgly_sticker_emoticons_asleep: 'Endormi',
      imgly_sticker_emoticons_attention: 'Attention',
      imgly_sticker_emoticons_baby_chicken: 'Poussin',
      imgly_sticker_emoticons_batman: 'Batman',
      imgly_sticker_emoticons_beer: 'Bière',
      imgly_sticker_emoticons_black: 'Noir',
      imgly_sticker_emoticons_blue: 'Bleu',
      imgly_sticker_emoticons_blush: 'Rougeur',
      imgly_sticker_emoticons_boxer:

      'Boxeur',
      imgly_sticker_emoticons_business: 'Business',
      imgly_sticker_emoticons_chicken: 'Poulet',
      imgly_sticker_emoticons_cool: 'Cool',
      imgly_sticker_emoticons_cry: 'Pleurer',
      imgly_sticker_emoticons_deceased: 'Décédé',
      imgly_sticker_emoticons_devil: 'Diable',
      imgly_sticker_emoticons_duckface: 'Duckface',
      imgly_sticker_emoticons_furious: 'Furieux',
      imgly_sticker_emoticons_grin: 'Sourire',
      imgly_sticker_emoticons_guitar: 'Guitare',
      imgly_sticker_emoticons_harry_potter: 'Harry Potter',
      imgly_sticker_emoticons_hippie: 'Hippie',
      imgly_sticker_emoticons_hitman: 'Tueur à gages',
      imgly_sticker_emoticons_humourous: 'Drôle',
      imgly_sticker_emoticons_idea: 'Idée',
      imgly_sticker_emoticons_impatient: 'Impatient',
      imgly_sticker_emoticons_kiss: 'Baiser',
      imgly_sticker_emoticons_kisses: 'Bisous',
      imgly_sticker_emoticons_laugh: 'Rire',
      imgly_sticker_emoticons_loud_cry: 'Crier fort',
      imgly_sticker_emoticons_loving: 'Amoureux',
      imgly_sticker_emoticons_masked: 'Masqué',
      imgly_sticker_emoticons_music: 'Musique',
      imgly_sticker_emoticons_nerd: 'Nerd',
      imgly_sticker_emoticons_ninja: 'Ninja',
      imgly_sticker_emoticons_not_speaking_to_you: 'Je ne te parle pas',
      imgly_sticker_emoticons_pig: 'Cochon',
      imgly_sticker_emoticons_pumpkin: 'Citrouille',
      imgly_sticker_emoticons_question: 'Question',
      imgly_sticker_emoticons_rabbit: 'Lapin',
      imgly_sticker_emoticons_sad: 'Triste',
      imgly_sticker_emoticons_sick: 'Malade',
      imgly_sticker_emoticons_skateboard: 'Planche à roulettes',
      imgly_sticker_emoticons_skull: 'Crâne',
      imgly_sticker_emoticons_sleepy: 'Endormi',
      imgly_sticker_emoticons_smile: 'Sourire',
      imgly_sticker_emoticons_smoking: 'Fumer',
      imgly_sticker_emoticons_sobbing: 'Hurler',
      imgly_sticker_emoticons_star: 'Étoile',
      imgly_sticker_emoticons_steaming_furious: 'Furieux bouillonnant',
      imgly_sticker_emoticons_sunbathing: 'Bronzage',
      imgly_sticker_emoticons_tired: 'Fatigué',
      imgly_sticker_emoticons_tongue_out_wink: 'Langue sortie clin d\'œil',
      imgly_sticker_emoticons_wave: 'Vague',
      imgly_sticker_emoticons_wide_grin: 'Grand sourire',
      imgly_sticker_emoticons_wink: 'Clin d\'œil',
      imgly_sticker_emoticons_wrestler: 'Lutteur',
      imgly_sticker_shapes_arrow_02: 'Flèche 1',
      imgly_sticker_shapes_arrow_03: 'Flèche 2',
      imgly_sticker_shapes_badge_01: 'Badge 1',
      imgly_sticker_shapes_badge_11: 'Badge 5',
      imgly_sticker_shapes_badge_12: 'Badge 6',
      imgly_sticker_shapes_badge_13: 'Badge 7',
      imgly_sticker_shapes_badge_15: 'Badge 8',
      imgly_sticker_shapes_badge_18: 'Badge 9',
      imgly_sticker_shapes_badge_19: 'Badge 10',
      imgly_sticker_shapes_badge_20: 'Badge 11',
      imgly_sticker_shapes_badge_28: 'Badge 12',
      imgly_sticker_shapes_badge_32: 'Badge 13',
      imgly_sticker_shapes_badge_35: 'Badge 14',
      imgly_sticker_shapes_badge_36: 'Badge 15',
      imgly_sticker_shapes_badge_04: 'Badge 2',
      imgly_sticker_shapes_badge_06: 'Badge 3',
      imgly_sticker_shapes_badge_08: 'Badge 4',
      imgly_sticker_shapes_spray_01: 'Spray 1',
      imgly_sticker_shapes_spray_03: 'Spray 2',
      imgly_sticker_shapes_spray_04: 'Spray 3'
    },
    canvasActions: {
      buttonDelete: 'Supprimer',
      buttonBringToFront: 'Amener au premier plan',
      buttonDuplicate: 'Dupliquer',
      buttonFlipHorizontal: 'Retourner horizontalement',
      buttonFlipVertical: 'Retourner verticalement'
    },
    history: {
      add: 'Autocollant',
      resize: 'Redimensionner l\'autocollant',
      position: 'Position de l\'autocollant',
      color: 'Couleur de l\'autocollant',
      delete: 'Supprimer l\'autocollant',
      order: 'Ordre de l\'autocollant',
      opacity: 'Opacité de l\'autocollant',
      flip: 'Retournement de l\'autocollant'
    }
  },
  text: {
    title: 'Texte',
    controls: {
      buttonNew: 'Nouveau texte',
      dropdownFontFamily: 'Police',
      textFontSize: 'Taille',
      selectAlignment: 'Alignement',
      selectFontColor: 'Couleur du texte',
      selectBackgroundColor: 'Couleur du fond',
      sliderLineSpacing: 'Espacement des lignes',
      tabColor: 'Couleur',
      tabBgColor: 'Couleur de fond',
      tabAlignment: 'Alignement',
      tabLineHeight: 'Hauteur de ligne',
      tabFontSize: 'Taille de la police'
    },
    canvasControls: {
      placeholderText: 'Écrivez quelque chose',
      buttonSave: 'Terminé',
      buttonClose: 'Annuler',
      inputText: 'Tapez votre texte'
    },
    canvasActions: {
      buttonEdit: 'Modifier',
      buttonDelete: 'Supprimer',
      buttonBringToFront: 'Amener au premier plan',
      buttonDuplicate: 'Dupliquer'
    },
    history: {
      add: 'Texte',
      edit: 'Modifier le texte',
      resize: 'Redimensionner le texte',
      position: 'Position du texte',
      alignment: 'Alignement du texte',
      textColor: 'Couleur du texte',
      backgroundColor: 'Couleur de fond du texte',
      fontFamily: 'Police',
      fontStyle: 'Style de police',
      lineSpacing: 'Espacement des lignes',
      width: 'Largeur du texte',
      delete: 'Supprimer le texte',
      order: 'Ordre du texte'
    }
  },
  textdesign: {
    title: 'Design de texte',
    controls: {
      buttonNew: 'Nouveau design',
      buttonShuffle: 'Variante',
      selectColor: 'Couleur du design',
      tabColor: 'Couleur',
      tabShuffle: 'Mélanger'
    },
    canvasControls: {
      placeholderText: 'Écrivez quelque chose avec style',
      buttonSave: 'Terminé',
      buttonClose: 'Fermer',
      inputText: 'Tapez votre texte'
    },
    canvasActions: {
      buttonEdit: 'Modifier',
      buttonInvert: 'Inverser',
      buttonDelete: 'Supprimer',
      buttonBringToFront: 'Amener au premier plan',
      buttonDuplicate: 'Dupliquer'
    },
    history: {
      add: 'Design de texte',
      edit: 'Modifier le design',
      resize: 'Redimensionner le design',
      position: 'Position du design',
      color: 'Couleur du design',
      shuffle: 'Mélanger le design',
      invert: 'Inverser le design',
      padding: 'Marge du design',
      order: 'Ordre du design',
      delete: 'Supprimer le design'
    }
  },
  frame: {
    title: 'Cadres',
    controls: {
      buttonReset: 'Supprimer le cadre',
      sliderOpacity: 'Opacité du cadre',
      sliderSize: 'Taille du cadre',
      selectColor: 'Couleur du cadre',
      tabColor: 'Couleur',
      tabOpacity: 'Opacité',
      tabSize: 'Taille'
    },
    items: {
      imgly_frame_dia: 'Dia',
      imgly_frame_art_decor: 'Décor artistique',
      imgly_frame_black_passepartout: 'Noir',
      imgly_frame_lowpoly_shadow: 'Low Poly',
      imgly_frame_wood_passepartout: 'Bois'
    }
  },
  brush: {
    title: 'Pinceau',
    controls: {
      buttonReset: 'Supprimer le pinceau',
      sliderSize: 'Taille du pinceau',
      sliderHardness: 'Dureté du pinceau',
      selectColor: 'Couleur du pinceau',
      tabSize: 'Taille',
      tabHardness: 'Dureté',
      tabColor: 'Couleur'
    },
    history: {
      brushStroke: 'Coup de pinceau'
    }
  },
  transform: {
    title: 'Transformer',
    controls: {
      buttonReset: 'Réinitialiser',
      checkboxKeepResolution: 'Conserver la résolution',
      inputCropSize: 'Taille de recadrage',
      inputHeight: 'h',
      inputWidth: 'l',
      tabFlipAndRotate: 'Retourner et faire pivoter',
      tabResolution: 'Résolution',
      tabCropSize: 'Taille de recadrage'
    },
    categories: {
      imgly_transforms_common: 'Commun',
      imgly_transforms_facebook: 'Facebook',
      imgly_transforms_twitter: 'Twitter',
      imgly_transforms_instagram: 'Instagram'
    },
    items: {
      imgly_transform_common_custom: 'Personnalisé',
      imgly_transform_common_square: 'Carré',
      imgly_transform_common_4: '4:3',
      imgly_transform_common_16: '16:9',
      imgly_transform_common_3: '3:4',
      imgly_transform_common_9: '9:16',
      imgly_transform_facebook_profile: 'Profil',
      imgly_transform_facebook_title: 'Titre',
      imgly_transform_facebook_post: 'Publication',
      imgly_transform_instagram_story: 'Story',
      imgly_transform_instagram_landscape: 'Paysage',
      imgly_transform_instagram_portrait: 'Portrait',
      imgly_transform_instagram_square: 'Carré',
      imgly_transform_twitter_profile: 'Profil',
      imgly_transform_twitter_title: 'Titre',
      imgly_transform_twitter_post: 'Publication'
    },
    transformActions: {
      buttonFlipHorizontal: 'Retourner horizontalement',
      buttonFlipVertical: 'Retourner verticalement',
      buttonRotateClockwise: 'Faire pivoter dans le sens des aiguilles d\'une montre',
      buttonRotateAntiClockwise: 'Faire pivoter dans le sens inverse des aiguilles d\'une montre'
    }
  }
}
